module.exports = __webpack_public_path__ + "media/memory-bank/level1-avatar-ab847019.png";